import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

/*** PAGE */
import Home from "../views/Home.vue";
import Login from "../views/Login";
import LottoHolidays from "../views/LottoHolidays";
import LottoResults from "../views/LottoResults";
import LottoWaitingResults from "../views/LottoWaitingResults";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            requiresGuest: true,
        },
    },
    {
        path: "/holidays",
        name: "Holidays",
        component: LottoHolidays,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
        },
    },
    {
        path: "/lotto-results",
        name: "LottoResults",
        component: LottoResults,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/lotto-waiting-results",
        name: "LottoWaitingResults",
        component: LottoWaitingResults,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
        },
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

/** NAVIGATIONS GUARD */
router.beforeEach((to, from, next) => {
    /** REQUIRES AUTH */
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!store.getters["auth/isLoggedIn"]) {
            next({
                name: "Login",
            });
        } else if (
            to.matched.some((record) => record.meta.requiresAdmin) &&
            !store.getters["auth/isAdmin"]
        ) {
            next({
                path: "/",
            });
        } else {
            next();
        }
    } else if (to.matched.some((record) => record.meta.requiresGuest)) {
        /** REQUIRES GUEST */
        if (store.getters["auth/isLoggedIn"]) {
            next({
                path: "/",
            });
        } else {
            next();
        }
    } else {
        /** OTHER PAGE */
        next();
    }
});

export default router;
